import InlineLoves from 'components/Header/InlineLoves/InlineLoves';
import { withInlineLovesProps } from 'viewModel/richProfile/myLists/inlineLoves/withInlineLovesProps';

export default withInlineLovesProps(InlineLoves);
